/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CounterpartyType {
    TWO_SIGNATORIES = 'TWO_SIGNATORIES',
    ONE_SIGNATORIES = 'ONE_SIGNATORIES',
}
